import { MeterRateTaskType } from '../redux/jobs/jobs.types';
import { shortenObis } from './MeterHelper';
import dotProp from 'dot-prop-immutable';

export const sortMeterRates = (meterRates: MeterRateTaskType[]) => {
    return meterRates.sort((a, b) => {
        if (!a.obis || !b.obis) {
            if (a.rateName && b.rateName) return a.rateName.localeCompare(b.rateName);
        }

        if (a.obis === b.obis) {
            if (a.targetReadingDate && b.targetReadingDate) {
                return b.targetReadingDate.localeCompare(a.targetReadingDate);
            }
        }

        if (shortenObis(a.obis).startsWith('1.6')) {
            return 1;
        }

        if (shortenObis(b.obis).startsWith('1.6')) {
            return -1;
        }

        if (a.obis && b.obis) return a.obis.localeCompare(b.obis);

        return 0;
    });
};

export const compareBySortSettings = (
    a: any,
    b: any,
    sortSettings: {
        fields: {fieldName: string, direction: 'ASC' | 'DESC'}[];
    },
): number => {
    for (const { fieldName, direction } of sortSettings.fields) {
        const dir = direction === 'DESC' ? -1 : 1;

        const av = dotProp.get(a, fieldName);
        const bv = dotProp.get(b, fieldName);

        // null / undefined handling
        if (av == null && bv == null) continue;
        if (av == null) return 1 * dir;
        if (bv == null) return -1 * dir;

        let result = 0;

        if (typeof av === 'string' && typeof bv === 'string') {
            result = av.localeCompare(bv);
        } else if (typeof av === 'number' && typeof bv === 'number') {
            result = av - bv;
        } else {
            result = String(av).localeCompare(String(bv));
        }

        if (result !== 0) {
            return result * dir;
        }
    }

    // Alle Felder gleich
    return 0;
};
